import React from 'react';

import { IconProps } from './type';

export default function MailIcon({
  size = 18,
  className,
  ...props
}: React.ComponentProps<'svg'> & IconProps) {
  return (
    <svg
      width={size}
      height={(size * 14) / 18}
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M3.37499 0.335449H14.625C15.3168 0.335404 15.9823 0.600077 16.4852 1.07518C16.988 1.55027 17.29 2.19978 17.3292 2.89045L17.3333 3.04378V10.9604C17.3334 11.6522 17.0687 12.3178 16.5936 12.8206C16.1185 13.3235 15.469 13.6255 14.7783 13.6646L14.625 13.6688H3.37499C2.68321 13.6688 2.01763 13.4042 1.5148 12.9291C1.01196 12.454 0.709989 11.8045 0.670823 11.1138L0.666656 10.9604V3.04378C0.666611 2.352 0.931285 1.68643 1.40638 1.18359C1.88148 0.680755 2.53098 0.378781 3.22166 0.339616L3.37499 0.335449ZM16.0833 4.81295L9.29166 8.38795C9.21497 8.42846 9.13069 8.45257 9.04418 8.45874C8.95767 8.46491 8.87082 8.453 8.78916 8.42378L8.70916 8.38878L1.91666 4.81378V10.9604C1.91667 11.3264 2.0543 11.679 2.30222 11.9483C2.55015 12.2175 2.89024 12.3837 3.25499 12.4138L3.37499 12.4188H14.625C14.9911 12.4188 15.3438 12.281 15.6131 12.0329C15.8823 11.7848 16.0484 11.4445 16.0783 11.0796L16.0833 10.9604V4.81295ZM14.625 1.58545H3.37499C3.009 1.58546 2.65639 1.72309 2.38716 1.97102C2.11794 2.21894 1.95177 2.55903 1.92166 2.92378L1.91666 3.04378V3.40128L8.99999 7.12962L16.0833 3.40045V3.04378C16.0833 2.67766 15.9455 2.32494 15.6975 2.05569C15.4494 1.78644 15.1091 1.62037 14.7442 1.59045L14.625 1.58545Z"
        fill="currentColor"
      />
    </svg>
  );
}
